/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { adminModelSchema } from "./adminModelSchema.ts";
import { z } from "zod";

export const adminModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => adminModelSchema))
    })